import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { from, map, Observable, of, switchMap } from 'rxjs';
// import { Components } from './components';
import { ISbStoryData } from '@storyblok/js';
import { forkJoinSafe } from '../lib/safe-fork-join';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';
import { StoryblokLoadComponentsService } from '../services/storyblok-load-components.service';

export const storyblokUpdates: ResolveFn<Observable<ISbStoryData[]>> = route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  const storyblokLoadComponentsService = inject(StoryblokLoadComponentsService);
  return storyblokService.getUniqueComponentsList(route).pipe(
    switchMap(components => {
      if (components.has('Updates')) {
        return storyblokService
          .getStories({
            content_type: 'Update',
            sort_by: 'first_published_at:desc',
          })
          .pipe(
            map(resp => resp.stories),
            switchMap(stories =>
              forkJoinSafe(
                stories.map(story =>
                  from(storyblokService.prepLoadComponents(story)).pipe(
                    switchMap(componentTypes => from(storyblokLoadComponentsService.loadComponents(componentTypes)))
                  )
                )
              ).pipe(map(() => stories))
            )
          );
      }
      return of(undefined);
    })
  );
};
